import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language } = useLanguage();
  const t = translations[language];

  const navLinks = [
    { name: t.nav.home, href: '#home' },
    { name: t.nav.apps, href: '#apps' },
    { name: t.nav.services, href: '#services' },
    { name: t.nav.about, href: '#about' },
    { name: t.nav.contact, href: '#contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a1c1b]/95 backdrop-blur-sm border-b border-[#1e3a5f]/50">
      <div className="max-w-[87.5rem] mx-auto px-10 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-2">
            <span className="text-[#7dd3fc] font-black text-2xl tracking-tight">RDK</span>
            <span className="text-white font-medium text-lg">Services</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-2">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="nav-link text-[#7dd3fc] hover:text-[#7dd3fc]/80 px-4 py-2 text-base font-medium transition-all duration-300"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Right side - Language Switcher + CTA */}
          <div className="hidden md:flex items-center gap-4">
            <LanguageSwitcher />
            <Button 
              className="bg-[#7dd3fc] text-[#1a1c1b] hover:bg-[#7dd3fc]/90 rounded-full px-6 py-2 font-semibold uppercase tracking-wide text-sm transition-transform hover:scale-[1.02] active:scale-[0.98]"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              {t.nav.getInTouch}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#7dd3fc] p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden pt-4 pb-2 border-t border-[#1e3a5f]/50 mt-4">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-[#7dd3fc] hover:text-[#7dd3fc]/80 px-4 py-3 text-base font-medium transition-all"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <div className="px-4 py-2">
                <LanguageSwitcher />
              </div>
              <Button 
                className="bg-[#7dd3fc] text-[#1a1c1b] hover:bg-[#7dd3fc]/90 rounded-full px-6 py-3 font-semibold uppercase tracking-wide text-sm mt-2 w-full"
                onClick={() => {
                  setIsMenuOpen(false);
                  document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {t.nav.getInTouch}
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
